import React, { useState, useEffect, useRef } from 'react';
import './css/Navbar.css';
import logo_mat from './images/logo_nqtb_300x300.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faQuestion, faSignOutAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { IoLogOutOutline, IoLogInOutline, IoPencilOutline, IoMailOutline, IoHelp } from 'react-icons/io5';
import { Link, useLocation } from 'react-router-dom'
import { IoPersonOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import token_icon from './images/token_nqtb.png'
import authService from '../auth/authService';
import labService from './labService'

const Navbar = () => {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const menuRef = useRef(null);
    const menuButtonRef = useRef(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUserData = async () => {
            const userData = localStorage.getItem('user');
            if (!userData) {
                setLoading(false);
                return;
            }

            const parsedUserData = JSON.parse(userData);
            const token = parsedUserData.access;
            if (!token) {
                setLoading(false);
                return;
            }

            try {
                const response = await labService.getUserInfo(token);
                setUser(response.data);
            } catch (error) {
                console.error('Error fetching user data', error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(prevState => !prevState);
    };

    const handleMenuItemClick = (path) => {
        navigate(path);
        setIsMenuOpen(false);
    };

    const handleClickOutside = (event) => {
        if (
            menuRef.current &&
            !menuRef.current.contains(event.target) &&
            menuButtonRef.current &&
            !menuButtonRef.current.contains(event.target)
        ) {
            setIsMenuOpen(false);
        }
    };

    const handleLogout = () => {
        authService.logout();
        window.location.reload();
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <nav className="navbar">
            <div className="left">
                <a href='/'>
                    <img className="logo-nav" src={logo_mat} alt="logo" />
                </a>
            </div>
            <nav className="center-nav">
                {[
                    { name: 'Laboratory', path: '/laboratory' },
                    { name: 'Licenses', path: '/wallet' },
                ].map((route) => {
                    const isActive = location.pathname === route.path;

                    if (route.isExternal) {
                        return (
                            <div key={route.name} className="tab-link-wrapper" onClick={() => window.open(route.path, "_blank")}>
                                <span className="tab-link-text">{route.name}</span>
                                <div className='chakra-fade'>
                                    <div className="tab-underline" />
                                </div>
                            </div>
                        );
                    }

                    return (
                        <div key={route.name} className="tab-link-wrapper">
                            <Link
                                to={route.path}
                                className={`tab-link-text ${isActive ? 'active-nav' : ''}`}
                            >
                                {route.name}
                            </Link>
                            <div className={`tab-underline ${isActive ? 'visible' : ''}`} />
                        </div>
                    );
                })}
            </nav>
            <div className="right">

                <p className="user-email">
                    {user?.email || "j.kowalski@qsarlab.com"}
                </p>

                <div className='user-menu'>

                    <button
                        aria-label="Options"
                        className="custom-menu-button"
                        onClick={toggleMenu}
                        ref={menuButtonRef}
                    >
                        <IoPersonOutline size="1.5rem" color='white' />
                    </button>
                    <div className={`dropdown-menu ${isMenuOpen ? 'open' : ''}`} ref={menuRef}>
                        {/* Edit Company Data */}
                        <div className="menu-item" onClick={() => handleMenuItemClick('/user-form')}>
                            <IoPencilOutline className="menu-icon blue-icon" />
                            <span className="menu-text">Edit company data</span>
                        </div>

                        {/* Contact Us */}
                        <div className="menu-item" onClick={() => handleMenuItemClick('/contact')}>
                            <IoMailOutline className="menu-icon blue-icon" />
                            <span className="menu-text">Contact us</span>
                        </div>

                        {/* FAQ */}
                        <div className="menu-item" onClick={() => window.open("https://sites.google.com/view/nqtb-faq", "_blank")}>
                            <IoHelp className="menu-icon blue-icon" />
                            <span className="menu-text">FAQ</span>
                        </div>


                        {/* Logout */}
                        <div className="menu-item logout-item" onClick={() => handleLogout()}>
                            <IoLogOutOutline className="red-icon menu-icon" />
                            <span className="menu-text red-text">Logout</span>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
